// extracted by mini-css-extract-plugin
export default {"btn_parent":"downloadBtns_btn_parent__7bdcp","btn":"downloadBtns_btn__becAL","btn_icon":"downloadBtns_btn_icon__guhKB","btn_text":"downloadBtns_btn_text__Eeuyl"};